import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-forgot-password',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, RouterLink],
    template: `
  <div class="forgot-wrap">
    <div class="card">
      <h2 class="title">Recupera tu contraseña</h2>
      <p class="desc">Te enviaremos un enlace al correo registrado (si existe) para restablecer la contraseña.</p>

      <form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="!submitted">
        <label class="label">Correo electrónico</label>
        <input class="input" formControlName="email" type="email" autocomplete="email" />
        <button class="btn primary" [disabled]="form.invalid || loading" type="submit">
          {{ loading ? 'Enviando…' : 'Enviar enlace de recuperación' }}
        </button>
        <a routerLink="/login" class="btn secondary">Volver al login</a>
      </form>

      <div class="success" *ngIf="submitted">
        <p>Si el correo existe, hemos enviado un enlace de recuperación.</p>
        <p>Revisa tu bandeja de entrada y sigue las instrucciones.</p>
        <div class="actions">
          <a routerLink="/login" class="btn primary">Volver al login</a>
        </div>
      </div>
    </div>
  </div>
  `,
    styles: [`
    .forgot-wrap{display:flex;align-items:flex-start;justify-content:center;min-height:80vh;padding:24px;background:#e7efe7}
    .card{max-width:520px;width:100%;background:#fff;border-radius:12px;box-shadow:0 8px 20px rgba(0,0,0,.08);padding:24px}
    .title{margin:0 0 8px 0;font-size:22px;font-weight:800;color:#374151}
    .desc{margin:0 0 18px;color:#6b7280}
    .label{display:block;margin:12px 0 6px;color:#374151}
    .input{width:100%;padding:12px;border:1px solid #d1d5db;border-radius:8px;background:#fff}
    .btn{appearance:none;border:none;border-radius:8px;padding:12px 16px;background:#f3f4f6;color:#111827;font-weight:600;cursor:pointer;text-decoration:none;margin-right:8px}
    .btn.primary{background:var(--primary);color:#fff;margin-top:16px}
    .btn.secondary{background:#f3f4f6;color:#111827;margin-top:16px}
    .success{margin-top:8px;color:#065f46;background:#d1fae5;border:1px solid #a7f3d0;padding:12px;border-radius:8px}
    .actions{margin-top:12px}
  `]
})
export class ForgotPasswordComponent {
    form = this.fb.group({
        email: ['', [Validators.required, Validators.email]],
    });
    loading = false;
    submitted = false;

    constructor(private fb: FormBuilder) { }

    async onSubmit() {
        if (this.form.invalid || this.loading) return;
        this.loading = true;
        try {
            // Aquí se puede integrar una llamada al backend si existe (p.ej. /auth/password/reset-request)
            // Por ahora solo mostramos confirmación sin revelar existencia del correo.
            this.submitted = true;
        } catch (e) {
            console.error('Error en recuperación', e);
            this.submitted = true; // Misma UX por seguridad
        } finally {
            this.loading = false;
        }
    }
}